(() => {
  angular
    .module('complianceFrameworkApp.complianceFramework')
    .controller('LandingController', LandingController);

  /* ngInject */
  function LandingController(contactRequestService, usStates) {

    const vm = this;

    vm.contact = {state: 'AL', product: 'Compliance Advisory'};
    vm.states = usStates;
    vm.submitContactRequest = submitContactRequest;
    vm.isValidContactInfo = isValidContactInfo;
    vm.isValidEmail = isValidEmail;
    vm.isValidPhoneNumber = isValidPhoneNumber;

    function isValidEmail(email) {      
      return (/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/).test(email);
    }
    
    function isValidContactInfo(contact) {      
      if (contact.name && contact.institution_name && vm.isValidEmail(contact.email) && vm.isValidPhoneNumber(contact.phone) && contact.state && contact.product) {
        return true;
      }
    }
    
    function isValidPhoneNumber(number) {
      return (/^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im).test(number);
    }

    function submitContactRequest() {             
      contactRequestService.save({contact_request: vm.contact}, _response => { 
        vm.submitContactRequestSuccess = vm.isValidContactInfo(vm.contact) || false; 
      });
    }
  }

})();
